// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const CaretUp: React.FC<{ width?: number; height?: number }> = ({ width = 9, height = 5 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 9 5">
            <path
                fill="currentColor"
                d="M8.239 5a.768.768 0 0 0 .702-.446.698.698 0 0 0-.164-.782L5.032.201a.822.822 0 0 0-1.077 0L.211 3.772c-.211.201-.281.514-.14.782A.735.735 0 0 0 .748 5h7.49Z"
            />
        </svg>
    );
};

export default React.memo(CaretUp);
